import { createActionTypes } from '../../../util/createActionsHelpers';

export const SEARCH = createActionTypes('SEARCH');
